// 14-B8 — THE SENTENCE WITH HER READING'S NAME IN IT, AND WHY IT IS SPLIT ON A TOKEN.
//
// The generation follower rides on EVERY page in the house (N1-2), and two of its sentences are the
// member's own reading NAME in bold followed by what is happening to it: "**Your Birth Chart** is
// being prepared", "**Your Birth Chart** is ready".
//
// The name is SERVER-COMPOSED and stays exactly as the ledger recorded it (14-B3's seam, the same
// ruling that keeps the money page's prices English). The sentence AROUND it turns, and it cannot be
// two rows joined at a `<strong>`: **English puts the subject first and Spanish does not have to.**
// A row like "is ready" would nail the word order to English's and hand a translator no way out —
// which is 14-B5's mail badge (`${n} new messages`) one control over.
//
// So the row carries a `{label}` token, the component SPLITS on it, and the bold goes where the
// token was. A row that lost its token still renders every word of it with the name after — a
// translation can cost the word ORDER and can never cost her the name.
//
// Props in, tree out, no hook — so `scripts/item14-strings.mjs` CALLS it in both languages rather
// than reading a ternary out of a 13,000-line file.
import { t } from "../strings.js";

export function GenerationLine({ language, textKey, label }: { language: string; textKey: string; label: string }) {
  const [before, after = ""] = t(language, textKey).split("{label}");
  return <>{before}<strong>{label}</strong>{after}</>;
}
